import deepcopy from 'lodash.clonedeep'
import { initialState, getProducts } from '.'
import Actions from '../../constants/hookLogic'

// -------------------------------------------------
// ACTIONS
// -------------------------------------------------
export const handleHookLogic = products => ({ type: Actions.RECEIVED_HOOK_LOGIC_PRODUCTS, products })
export const showHookLogicProducts = () => ({ type: Actions.SHOW_HOOK_LOGIC_PRODUCTS })
export const hideHookLogicProducts = () => ({ type: Actions.HIDE_HOOK_LOGIC_PRODUCTS })
export const onBeaconSent = payload => ({ type: Actions.BEACON_SENT, productSku: payload.productSku })
export const clearHookLogicProducts = () => ({ type: Actions.CLEAR_HOOK_LOGIC_PRODUCTS })

// -------------------------------------------------
// REDUCER
// -------------------------------------------------
export default (state = initialState, action) => {
  const newState = deepcopy(state)

  switch (action.type) {
    case Actions.RECEIVED_HOOK_LOGIC_PRODUCTS:
      newState.products = getProducts(action.products)
      return newState
    case Actions.SHOW_HOOK_LOGIC_PRODUCTS:
      newState.show = true
      return newState
    case Actions.HIDE_HOOK_LOGIC_PRODUCTS:
      newState.show = false
      return newState
    case Actions.BEACON_SENT:
      newState.products = newState.products.map(product => {
        if (product.id === action.productSku) {
          // eslint-disable-line
          product.attributes = { ...product.attributes, beaconSent: true }
        }
        return product
      })
      return newState
    case Actions.CLEAR_HOOK_LOGIC_PRODUCTS:
      if (state.products.length > 0) {
        newState.products = []
        return newState
      }
      return state
    default:
      return state
  }
}
